import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { isQA } from './getEnvironment';
import initialParamsByBrand from '../constants/initialParamsByBrand';
export default function getConfigByBrand(brand) {
  const env = isQA() ? 'qa' : 'prod';

  // always take prod config by default
  const defaultSet = _get(initialParamsByBrand, ['params', brand, 'prod'], {});
  const envSet = _get(initialParamsByBrand, ['params', brand, env], {});
  return _merge(defaultSet, envSet);
}